export default "/images/welcome.png"